import { AssetDto } from '../../models';

export const validateAsset = (item: AssetDto) => {
  const fields: (keyof AssetDto)[] = [];

  if (typeof item.country !== 'string') fields.push('country');
  if (item.purchaseValue === undefined || typeof item.purchaseValue.value !== 'number') {
    fields.push('purchaseValue');
  }

  return { valid: fields.length === 0, fields };
};
